import { Box, Container, Grid, GridItem, Heading, Link, Stack, Text } from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const TerminosCondicionesGuiaBroker = () => {
    return (
        <Container maxWidth="100vw" pt={{ base: 14, md: 24 }} px={{ base: 4, lg: 7 }}>
            <Header />
            <Head>
                <title>
                    TÉRMINOS Y CONDICIONES DEL PROGRAMA DE REFERIDOS GUÍA CONNECT | Grupo Guía
                </title>
            </Head>
            <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                <GridItem colSpan={1} display={{ base: "none", md: "block" }} fontSize="16px">
                    <Stack mt="28" mb={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones"
                        >
                            Terminos y condiciones Contratación del portal
                        </Link>
                    </Stack>
                    <Stack pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiabroker"
                        >
                            Terminos y condiciones Guía broker
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiarent"
                        >
                            Terminos y condiciones Guía Rent
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/politicanodiscriminacion"
                        >
                            Política de no discriminación
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/cartaderechosconsumidor"
                        >
                            Carta de derechos del consumidor
                        </Link>
                    </Stack>
                    <Stack my={4} borderLeftColor="#17669D" borderLeftWidth="3px" pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiaconnect"
                        >
                            Términos y condiciones Guia Connect
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-soyinmobiliaria"
                        >
                            Terminos y condiciones Soy Inmobiliaria
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-pagocomprasonline"
                        >
                            Términos y Condiciones para la Selección de Forma de Pago en Compras en
                            Línea
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-alianzas"
                        >
                            Términos y Condiciones - Guía Alianzas
                        </Link>
                    </Stack>
                </GridItem>
                <GridItem colSpan={{ base: 4, md: 3 }}>
                    <Box mb="4" mt="24">
                        <Heading
                            as="h1"
                            fontSize={{ md: "4xl", base: "2xl" }}
                            mb="8"
                            color="accent.500"
                            fontWeight="bold"
                            lineHeight={1.2}
                        >
                            TÉRMINOS Y CONDICIONES DEL PROGRAMA DE REFERIDOS GUÍA CONNECT:
                        </Heading>
                    </Box>
                    <Box lineHeight="2" mb="8">
                        <Text>
                            Los presentes términos y condiciones son aplicables para los servicios
                            identificados como GUIA CONNECT, en todo aquello que no se encuentre
                            contemplado o no contravenga a los “términos y condiciones generales de
                            GUIA EXCELENCIA INMOBILIARIA S.A. DE C.V.” mismos que pueden ser
                            consultados en www.grupoguia.mx y aplican como si a la letra se
                            insertasen.
                            <br />
                            <br />
                            Le recordamos que si usted es menor de edad o por disposición legal
                            usted debe ser representado por un tercero, deberá abstenerse de
                            participar en el programa de referidos GUIA CONNECT.
                            <br />
                            <br />
                            Al navegar y participar en el programa de referidos GUIA CONNECT se
                            encuentra dando su consentimiento en forma tácita, por lo que en caso de
                            no estar de acuerdo en la totalidad o parcialidad del contenido de estos
                            términos y condiciones, no debe continuar.
                            <br />
                            <br />
                            El Usuario debe leer, entender y aceptar todas las condiciones
                            establecidas en los Términos y Condiciones Generales, el Aviso de
                            Privacidad y cualquier documento en nuestro sitio web que se encuentre
                            relacionado con sus derechos y obligaciones, o los de un tercero. Mismos
                            que se encuentran a su disposición en www.grupoguia.mx.
                        </Text>
                    </Box>
                    <Box lineHeight="2" mb="12">
                        <Text mb={6} fontWeight="bold" fontSize="2xl" color="accent.500">
                            Términos
                        </Text>
                        <Text mb={10}>
                            Para los propósitos de este documento, se aplican en singular o plural
                            indistintamente, los términos, definiciones y términos abreviados
                            siguientes:
                            <br />
                            <br />
                            <strong>Auto referencia:</strong> Se refiere a la acción en la que un
                            referidor se refiere a sí mismo.
                            <br />
                            <br />
                            <strong>Bono de referido:</strong> Se llama la cantidad de dinero que
                            será depositada en el monedero electrónico
                            <br />
                            <br />
                            <strong>CRM:</strong> Es el sistema a través del cual GUIA inscribe a
                            los referidos y permite identificarlo para un inmueble y referidos en
                            específico.
                            <br />
                            <br />
                            <strong>Guia:</strong> Se refiere a GUIA EXCELENCIA INMOBILIARIA S.A. DE
                            C.V.
                            <br />
                            <br />
                            <strong>Referido:</strong> Persona física o moral no atendida o
                            registrada por GUIA en forma previa y recomendada por el referidor, para
                            realizar la compra de una propiedad comercializada por GUIA.
                            <br />
                            <br />
                            <strong>Referidor:</strong> Se refiere a la persona que
                            recomienda/refiere a un cliente nuevo para la compra de una propiedad
                            que es comercializada por GUIA.
                        </Text>
                        <Text mb={6} fontWeight="bold" fontSize="2xl" color="accent.500">
                            Condiciones
                        </Text>
                        <Text fontWeight="bold">1. Auto referencia</Text>
                        <Text pl={4} mb={8}>
                            No está permitido que el Referidor se refiera a sí mismo como referido.
                        </Text>
                        <Text fontWeight="bold">2. Exclusividad</Text>
                        <Text pl={4} mb={8}>
                            El programa de referidos está abierto únicamente para personas mayores
                            de edad (18 años o más) que residan legalmente en la República de los
                            Estados Unidos Mexicanos. En este programa no pueden participar como
                            referidores las inmobiliarias o corredores inmobiliarios, es decir,
                            personas que se dediquen en forma habitual a la intermediación comercial
                            de bienes inmuebles.
                        </Text>
                        <Text fontWeight="bold">3. Participación</Text>
                        <Text pl={4} mb={8}>
                            Para participar en el programa de referidos, debes ser un individuo
                            registrado en el programa y aceptar los términos y condiciones
                            establecidos aquí.
                        </Text>
                        <Text fontWeight="bold">4. Validez de la referencia</Text>
                        <Text pl={4} mb={8}>
                            Para que una referencia se considere válida deberá ser una persona
                            física o moral (cliente potencial) que tenga interés en adquirir un bien
                            inmueble comercializado por GUIA y que no haya tenido ningún tipo de
                            contacto previo con el desarrollo o producto que le sea ofrecido.
                            <br />
                            <br />
                            Previo a ser referido, el referidor deberá obtener consentimiento del
                            referido para proporcionar a GUIA sus datos de contacto: correo
                            electrónico, teléfono y nombre completo.
                            <br />
                            <br />
                            El referido deberá encontrarse al corriente en el cumplimiento de sus
                            obligaciones fiscales y no estar publicado dentro de las listas negras
                            del SAT, así como dedicarse a actividades lícitas.
                            <br />
                            <br />
                            No podrá ser referido una persona con la que se tenga una relación
                            contractual vigente.
                        </Text>
                        <Text fontWeight="bold">5. Operación independiente</Text>
                        <Text pl={4} mb={8}>
                            El programa de referidos opera de forma independiente y no se aplica en
                            conjunto con otras promociones o programas de incentivos de GUIA.
                        </Text>
                        <Text fontWeight="bold">6. Operación independiente</Text>
                        <Text pl={4} mb={8}>
                            Los pagos por referidos se realizarán de acuerdo a las condiciones
                            específicas establecidas en cada proyecto inmobiliario. Estas
                            condiciones incluirán el monto o porcentaje sobre cantidad determinada a
                            pagar por cada referido válido, así como los plazos de pago que no
                            podrán exceder a los indicados en el punto 8 de estos términos y
                            condiciones.
                        </Text>
                        <Text fontWeight="bold">7. Formalización de la compraventa</Text>
                        <Text pl={4} mb={8}>
                            El referido debe formalizar la compraventa de la unidad inmobiliaria, lo
                            que implica la firma del contrato privado correspondiente o
                            escrituración de la propiedad, así como el cumplimiento de los
                            requisitos de pago establecidos por la empresa desarrolladora para que
                            sea efectiva la referencia y por lo tanto genere una recompensa.
                        </Text>
                        <Text fontWeight="bold">8. Pago de bonos por referidos</Text>
                        <Text pl={4} mb={8}>
                            Una vez que el referido haya cumplido con los requisitos de
                            formalización de la compraventa, la empresa inmobiliaria Guía Excelencia
                            inmobiliaria S.A de C.V procederá a realizar el pago de la cantidad por
                            concepto de bono de referido que corresponda, en un periodo máximo de 45
                            días, a través de un monedero electrónico intransferible.
                            <br />
                            <br />
                            En algunos desarrollos participantes, el monto total del bono estará
                            divido en dos monederos electrónicos; como es el caso de Terrasoles,
                            Capital Sur, Kulkana y El Edén.
                            <br />
                            <br />
                            Si el Referidor cobra una comisión por segunda ocasión, se recargará el
                            monedero electrónico que se le entregó por primera vez. Es
                            responsabilidad del Referidor conservar y cuidar el monedero
                            electrónico. En caso de pérdida o extravío reportar de inmediato en la
                            App de BroxelPay. En caso de no cumplir con las indicaciones, Guía
                            Excelencia inmobiliaria S.A de C.V no se hace responsable.
                        </Text>
                        <Text fontWeight="bold">9. Limitaciones</Text>
                        <Text pl={4} mb={8}>
                            GUIA se reserva el derecho de modificar, suspender o cancelar el
                            programa de referidos en cualquier momento y sin previo aviso. GUIA no
                            se hace responsable por referidos que no cumplan con los requisitos
                            establecidos o por cualquier otro problema técnico o de otra índole que
                            pueda afectar la participación en el programa.
                        </Text>
                        <Text fontWeight="bold">10. Cumplimiento legal</Text>
                        <Text pl={4} mb={8}>
                            Tanto los participantes como GUIA se comprometen a cumplir con todas las
                            leyes y regulaciones aplicables en relación con el programa de referidos
                            GUIA CONNECT.
                        </Text>
                        <Text fontWeight="bold">11. Baja del programa</Text>
                        <Text pl={4} mb={8}>
                            En caso de no cumplir con los requisitos establecidos en los presentes
                            términos y condiciones, el referidor podrá ser dado de baja de inmediato
                            sin necesidad de previo aviso.
                            <br />
                            <br />
                            <br />
                            Si el referidor no registra ningún referido en un periodo de 6 meses,
                            podrá ser dado de baja sin previo aviso.
                            <br />
                            <br />
                            Deberá proporcionarnos, sin dilación, cualquier información que le
                            solicitemos para verificar su cumplimiento con este Acuerdo.
                            <br />
                            <br />
                            En caso de que usted incumpla con este Acuerdo o con los términos y
                            condiciones de cualquier otro acuerdo de GUIA aplicable, entonces, sin
                            perjuicio y en adición a cualquier otro derecho o recurso a nuestra
                            disposición, nos reservamos el derecho de suspender de forma temporal o
                            permanente (en la medida en que lo permita el derecho aplicable) (y
                            usted acepta y reconoce que no tendrá derecho a recibir) el pago de
                            todos y cada uno de los ingresos que, de otra manera, le serían
                            pagaderos a usted conforme a este Acuerdo, estén o no directamente
                            relacionados con dicho incumplimiento, sin que medie notificación previa
                            o necesidad de declaración judicial y sin perjuicio de cualquier derecho
                            de Amazon a recibir una indemnización por daños y perjuicios.
                        </Text>
                        <Text fontWeight="bold">12. Política del CRM</Text>
                        <Text pl={4} mb={8}>
                            Todos los referidos se rigen bajo las políticas del CRM de GUIA.
                        </Text>
                        <Text fontWeight="bold">13. Validación de referidos</Text>
                        <Text pl={4} mb={8}>
                            Todos los clientes que provengan de la página de TYA Rewards serán
                            validados por ambos equipos para determinar si el referidor será
                            acreedor al bono correspondiente. La notificación se realizará en un
                            período máximo de 48 horas. En caso de una validación negativa, se
                            informará al Referidor la justificación a través de correo electrónico.
                        </Text>
                        <Text fontWeight="bold">14. Exención de responsabilidad</Text>
                        <Text pl={4} mb={8}>
                            GUIA no se hace ni se hará responsable por el mal tratamiento de datos
                            personales proporcionados por usted para participar como referido. Una
                            vez que GUIA entre en contacto con el referido y obtenga con su
                            consentimiento expreso o tácito nuevos datos personales e información
                            confidencial respecto a su proyecto de inversión inmobiliaria, no serán
                            compartidos con el referidor.
                            <br />
                            <br />
                            GUIA no se hace responsable de las obligaciones fiscales del referidor
                            ni el referidor de las obligaciones fiscales de GUIA conforme a la
                            legislación aplicable. “Las partes” son independientes sin que exista
                            obligación solidaria.
                            <br />
                            <br />
                            La relación entre usted y GUIA es mercantil y nunca será entendida como
                            sociedad o alianza de ningún tipo. Usted no es empleado de GUIA con
                            motivo de este programa por lo que conoce no tiene derechos relacionados
                            con la Ley Federal del Trabajo al ser independiente, tener una relación
                            mercantil y no actuar bajo instrucciones de GUIA.
                            <br />
                            <br />
                            Cualquier controversia que surja con un tercero motivada por una acción
                            de su parte en contravención a lo dispuesto por estos términos y
                            condiciones, le hará responsable en forma directa.
                        </Text>
                        <Text fontWeight="bold">15. Modificación</Text>
                        <Text pl={4} mb={8}>
                            Nos reservamos el derecho de modificar, en cualquier momento y a nuestra
                            exclusiva discreción, cualquiera de los términos y condiciones
                            contenidos en este Acuerdo mediante la publicación de una notificación
                            de cambio, de un Acuerdo modificado o de una Política del Programa
                            modificada en el Sitio de GUIA CONNECT. La fecha de entrada en vigor de
                            dicho cambio será la fecha consignada en dicha notificación. SI USTED
                            CONTINUA PARTICIPANDO DESPUÉS DE LA FECHA DE ENTRADA EN VIGOR DE DICHO
                            CAMBIO CONSTITUIRÁ SU ACEPTACIÓN DE LAS MODIFICACIONES. EN CASO DE QUE
                            ALGUNA MODIFICACIÓN NO RESULTARA ACEPTABLE PARA USTED, SU ÚNICO RECURSO
                            SERÁ DAR POR TERMINADO ESTE ACUERDO.
                        </Text>
                        <Text fontWeight="bold">16. Propiedad intelectual</Text>
                        <Text pl={4} mb={8}>
                            Este acuerdo no le proporciona licencia y/o autorización sobre los
                            derechos de autor, derechos patrimoniales, marcas, avisos comerciales,
                            secreto comercial y derechos de propiedad intelectual en general en
                            favor del referidor. Este acuerdo no le otorga derecho a utilizar en
                            forma parcial o total la publicidad utilizada por GUIA en la promoción
                            de los inmuebles, debiendo limitarse a compartir o mostrar a su referido
                            en la forma que la misma publicidad lo indique.
                        </Text>
                        <Text fontWeight="bold">17. Jurisdicción y competencia</Text>
                        <Text pl={4} mb={8}>
                            {`Este Acuerdo se rige por las leyes aplicables en la República de los
                                Estados Unidos Mexicanos. Las partes acuerdan irrevocablemente que todas
                                las controversias, litigios y reclamaciones que surjan de alguna manera
                                en relación, asociación o conexión con el Programa de Guia Connect, este
                                Acuerdo o la relación entre las partes establecida por el mismo,
                                incluyendo, de manera enunciativa mas no limitativa, su existencia,
                                validez, cumplimiento, exigibilidad y terminación (conjuntamente, las
                                "Controversias") se resolverá en los Tribunales del Primer Partido
                                Judicial del Estado de Jalisco, zona metropolitana de Guadalajara.`}
                        </Text>
                        <Text pl={4} mb={8}>
                            Esta versión fue realizada el día 02 de agosto de 2023.
                        </Text>
                    </Box>
                </GridItem>
            </Grid>
            <Footer visible={false} />
        </Container>
    );
};

export default TerminosCondicionesGuiaBroker;
